import React from 'react';
import { useField, useForm } from 'react-final-form';
import { styled } from '@linaria/react';

import { PAPER_SIZE_VALUES } from '../../constants';
import { Label } from '../../ui';

const HighlightedLink = styled.span`
  color: ${({ active }) => (active ? 'var(--bb-label-color--active)' : 'var(--bb-label-color)')};
  &:hover {
    cursor: ${({ active }) => (active ? 'default' : 'pointer')};
  }
`;

const PaperSize = () => {
  const { mutators } = useForm();
  const { input } = useField('paper-size-type');
  const handleClick = value => () => {
    mutators.applyPaperSizeType(value);
  };
  return (
    <>
      <Label>
        <HighlightedLink
          active={input.value === PAPER_SIZE_VALUES.PAGES}
          onClick={handleClick(PAPER_SIZE_VALUES.PAGES)}
        >
          Pages
        </HighlightedLink>{' '}
        /{' '}
        <HighlightedLink
          active={input.value === PAPER_SIZE_VALUES.WORDS}
          onClick={handleClick(PAPER_SIZE_VALUES.WORDS)}
        >
          Words
        </HighlightedLink>
      </Label>
    </>
  );
};

export default PaperSize;
